<wide-dialog-wrapper
  [backgroundColor]="'#9FC5E8'"
  [dialogTitle]="'Manage Budget Costs Snapshot'"
  [disabled]="false"
  [deleteTitle]="'Delete'"
  [deleteText]="deleteText"
  [delete]="true"
  [successLabel]="'CLOSE'"
  (onSubmit)="exit()"
  (onDelete)="delete()"
>
  <div class="header">
    <h5 class="name">{{ data.info.name }} </h5>
    <div style="flex:1"></div>
    <h5 class="time">{{ data.info.timestamp | date:'h:mma, EEE d MMM'}}</h5>
  </div>
  <div *ngIf="loading">Loading snapshot...</div>
  <budget-report-view 
    *ngIf="!!budget && !!budgetSummary"
    [readOnly]="true" 
    [budget]="budget" 
    [budgetSummary]="budgetSummary"
    [cashFlowGrid]="cashFlowGrid"
  ></budget-report-view>
</wide-dialog-wrapper>